export default () => {
    const random = () => Math.random().toString(23).substring(2)
    
    return random() + random()
}